import { colors } from 'components/src/foundation';
import ArrowLeft from 'components/src/svg/ArrowLeft';
import { Subheading } from 'components/src/typography';
import * as React from 'react';
import { ContactFormFieldsFragment, ImageWithFocalPointFieldsFragment, Maybe } from 'types/generated';
import TextWithInlineColor from '../TextWithInlineColor';
import { ImageWithFocalPoint } from '../ImageWithFocalPoint';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, BLOCKS } from '@contentful/rich-text-types';
import { HeadingType } from '@/types';
import Button from 'components/src/button';
import VideoMedia from '@/components/common/VideoMedia';
import FormTabContent from '@/components/Contact/DoBusinessWithUsForm/FormTabContent';
import { useAtom } from 'jotai';
import { callMePrependTextAtom } from '@/store';

type Props = {
  data: ContactFormFieldsFragment;
  onClose: () => void;
  contactFormSetting?: Maybe<string>;
};

const renderImage = (
  imageData: {
    image: ImageWithFocalPointFieldsFragment | null | undefined;
    imageText: HeadingType;
    media?: {
      __typename?: 'Asset';
      title?: string | null;
      description?: string | null;
      contentType?: string | null;
      fileName?: string | null;
      size?: number | null;
      url?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
  } | null
) => {
  if (imageData?.media && imageData.media.url) {
    return <VideoMedia id={`contact-media-${imageData.media.title}`} url={imageData.media.url} fadeDirection="none" />;
  }
  if (imageData?.image) {
    return (
      <div className="relative h-[540px] md:h-full ">
        <ImageWithFocalPoint image={imageData.image} priority sizes={{ breakpoints: { md: '50vw' } }} />
        <div className="absolute bottom-[10%] z-50 mx-32 text-white-100">
          {imageData.imageText &&
            documentToReactComponents(imageData.imageText as Document, {
              renderNode: {
                [BLOCKS.HEADING_6]: (_node, children) => (
                  <Subheading classes="mb-24 text-black-100">{children}</Subheading>
                ),
              },
            })}
        </div>
      </div>
    );
  }
  return null;
};

const CallMeForm = ({ data, onClose }: Props) => {
  const [callMePrependText] = useAtom(callMePrependTextAtom);
  let mediaData = null;
  const tabContent = data.formTabsCollection?.items?.[0]?.content;
  if (tabContent?.__typename === 'Form') {
    mediaData = {
      image: tabContent.image,
      imageText: tabContent.imageText?.json,
      media: tabContent.media,
    };
  }

  return (
    <div className="grid max-h-[950px] grid-cols-12">
      <div
        className={
          'col-span-full rounded-28 bg-white-100 px-32 py-32 md:col-span-6 md:rounded-l-28 md:rounded-r-0 md:px-64'
        }
      >
        <Button
          label="Til baka"
          variant="text"
          bordered
          icon={<ArrowLeft color={colors.black[75]} />}
          onClick={onClose}
        />
        <div className="mt-32 flex flex-col gap-32">
          <TextWithInlineColor
            heading={data.title?.text?.json}
            headingVariant="large"
            textColor={'neutral-10'}
            color={data.title?.color}
            classes="!text-lg-fixed md:!text-2xl-fixed"
          />
          {data?.formTabsCollection?.items[0] && (
            <FormTabContent tab={data.formTabsCollection.items[0]} isCallMe prependDescription={callMePrependText} />
          )}
        </div>
      </div>
      <div className="col-span-full hidden h-full md:col-span-6 md:block">
        <div id="media-image-0" className="brand-fade sticky top-0 block h-full overflow-hidden rounded-r-28">
          {renderImage(mediaData)}
          <div className="brand-fade relative top-0 z-10 h-full w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default CallMeForm;
